/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clinicautocomplete_Noresults2Inputs */

const en_clinicautocomplete_noresults2 = /** @type {(inputs: Clinicautocomplete_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No clinics found. You can type the name manually.`)
};

const fr_clinicautocomplete_noresults2 = /** @type {(inputs: Clinicautocomplete_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune clinique trouvée. Vous pouvez taper le nom manuellement.`)
};

/**
* | output |
* | --- |
* | "No clinics found. You can type the name manually." |
*
* @param {Clinicautocomplete_Noresults2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const clinicautocomplete_noresults2 = /** @type {((inputs?: Clinicautocomplete_Noresults2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clinicautocomplete_Noresults2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clinicautocomplete_noresults2(inputs)
	return fr_clinicautocomplete_noresults2(inputs)
});
export { clinicautocomplete_noresults2 as "clinicAutocomplete_noResults" }